import React from 'react';
import { Spinner } from '@sravni/react-design-system';
import { useStyles } from '@sravni/react-utils';
import modules_56feba8c from './styles/TextInput.module.less.js';

const TextInput = React.forwardRef(({ icon, loading, value, ...props }, ref) => {
    const cx = useStyles(modules_56feba8c);
    const iconElement = () => {
        if (loading) {
            return React.createElement(Spinner, null);
        }
        if (icon) {
            return icon;
        }
        return null;
    };
    const onFocus = (e) => {
        if (props.onFocus) {
            props.onFocus(e);
        }
        setTimeout(() => {
            window.scrollTo(0, 0);
            document.body.scrollTop = 0;
        }, 200);
    };
    return (React.createElement("form", { className: cx('inputWrapper'), action: "", noValidate: true },
        React.createElement("input", { ref: ref, ...props, value: value, className: cx('searchInput'), type: "search", name: "search", autoComplete: "off", autoCapitalize: "off", autoCorrect: "off", onFocus: onFocus, spellCheck: false, autoFocus: true }),
        iconElement()));
});

export { TextInput };
//# sourceMappingURL=TextInput.js.map
